module.exports = __webpack_public_path__ + "static/media/r20.41bcbb02.jpg";